import {todayStr} from './dateUtils';

// ── Init ────────────────────────────────────────────────────────────

export const initIncome = () => ({
    type: 'FIXED',
    accountId: '', projectId: '',
    occurredOn: todayStr(), currencyCode: '',
    taxable: true,
    notes: '',
    amount: '', helperDeduction: '',
    rate: '', days: '', sharePercent: '100',
    adjustment: '',
});

export const initExpense = () => ({
    accountId: '', amount: '', currencyCode: '',
    title: '', occurredOn: todayStr(), notes: '',
});

export const initTransfer = () => ({
    accountId: '', transferAccountId: '',
    amount: '', currencyCode: '',
    differentCurrency: false,
    transferCurrencyCode: '', transferAmount: '',
    transferLoss: '',
    occurredOn: todayStr(), notes: '',
});

// ── Form ↔ item ─────────────────────────────────────────────────────

export const incomeToForm = (item) => {
    const d = item.movementDetails ?? {};
    return {
        type: d.type ?? 'FIXED',
        accountId: String(item.accountId ?? ''),
        projectId: item.projectId ? String(item.projectId) : '',
        occurredOn: item.occurredOn ?? todayStr(),
        currencyCode: item.currencyCode ?? '',
        taxable: item.taxable !== false,
        notes: item.notes ?? '',
        amount: d.amount != null ? String(d.amount) : '',
        helperDeduction: d.helperDeduction ? String(d.helperDeduction) : '',
        rate: d.rate != null ? String(d.rate) : '',
        days: d.days != null ? String(d.days) : '',
        sharePercent: d.sharePercent != null ? String(d.sharePercent) : '100',
        adjustment: d.adjustment != null ? String(d.adjustment) : '',
    };
};

export const transferToForm = (item) => ({
    accountId: String(item.accountId ?? ''),
    transferAccountId: item.transferAccountId ? String(item.transferAccountId) : '',
    amount: item.gross != null ? String(item.gross) : '',
    currencyCode: item.currencyCode ?? '',
    differentCurrency: !!(item.transferCurrencyCode && item.transferCurrencyCode !== item.currencyCode),
    transferCurrencyCode: item.transferCurrencyCode ?? '',
    transferAmount: item.transferAmount != null ? String(item.transferAmount) : '',
    transferLoss: item.transferLoss != null ? String(item.transferLoss) : '',
    occurredOn: item.occurredOn ?? todayStr(),
    notes: item.notes ?? '',
});

export const expenseToForm = (item) => ({
    accountId: String(item.accountId ?? ''),
    amount: item.gross != null ? String(item.gross) : '',
    currencyCode: item.currencyCode ?? '',
    title: item.title ?? '',
    occurredOn: item.occurredOn ?? todayStr(),
    notes: item.notes ?? '',
});

// ── Payload builders ────────────────────────────────────────────────

export const buildIncomePayload = (f) => {
    let movementDetails;
    if (f.type === 'FIXED') {
        movementDetails = {type: 'FIXED', amount: Number(f.amount), helperDeduction: Number(f.helperDeduction) || 0};
    } else if (f.type === 'RATE_BASED') {
        movementDetails = {
            type: 'RATE_BASED',
            rate: Number(f.rate), days: Number(f.days),
            sharePercent: Number(f.sharePercent),
            helperDeduction: Number(f.helperDeduction) || 0,
        };
    } else {
        movementDetails = {type: 'REVALUATION', adjustment: Number(f.adjustment)};
    }

    const taxable = f.type === 'REVALUATION' ? false : f.taxable !== false;

    return {
        type: 'INCOME',
        projectId: f.projectId ? Number(f.projectId) : null,
        accountId: Number(f.accountId),
        occurredOn: f.occurredOn,
        currencyCode: f.currencyCode,
        movementDetails,
        taxable,
        notes: f.notes || null,
    };
};

export const buildTransferPayload = (f) => ({
    type: 'TRANSFER',
    accountId: Number(f.accountId),
    transferAccountId: Number(f.transferAccountId),
    amount: Number(f.amount),
    currencyCode: f.currencyCode,
    transferCurrencyCode: f.differentCurrency ? f.transferCurrencyCode : f.currencyCode,
    transferAmount: f.differentCurrency
        ? Number(f.transferAmount)
        : Number(f.amount) - (Number(f.transferLoss) || 0),
    transferLoss: f.transferLoss ? Number(f.transferLoss) : null,
    occurredOn: f.occurredOn,
    notes: f.notes || null,
});

export const buildExpensePayload = (f) => ({
    type: 'EXPENSE',
    accountId: Number(f.accountId),
    amount: Number(f.amount),
    currencyCode: f.currencyCode,
    title: f.title || null,
    occurredOn: f.occurredOn,
    notes: f.notes || null,
});

// ── Preview ─────────────────────────────────────────────────────────

export const previewGross = (f) => {
    if (f.type === 'FIXED' && f.amount) {
        return Number(f.amount) - (Number(f.helperDeduction) || 0);
    }
    if (f.type === 'RATE_BASED' && f.rate && f.days && f.sharePercent) {
        return Number(f.rate) * 8 * Number(f.days) * Number(f.sharePercent) / 100 - (Number(f.helperDeduction) || 0);
    }
    if (f.type === 'REVALUATION' && f.adjustment) return Number(f.adjustment);
    return null;
};
